<template>
    <b-container>
        <b-jumbotron class="text-center">
            <b-skeleton-wrapper
                class="mt-3"
                :loading="loading"
            >
                <template #loading>
                    <b-skeleton></b-skeleton>
                </template>
            </b-skeleton-wrapper>
            <h3>{{ form.custom_submit_message || "Thank you for submitting the form!" }}</h3>
            <div class="mt-4">
                <router-link
                    is="b-button"
                    variant="primary"
                    :to="{ name: 'view_form2', params: { id: id, response_id: response_id }}"
                >
                    <font-awesome-icon
                        icon="eye"
                        class="mr-1"
                    ></font-awesome-icon>
                    View Response
                </router-link>
                <router-link
                    v-if="form.can_edit_response"
                    is="b-button"
                    variant="primary"
                    class="ml-2"
                    :to="{ name: 'edit_form2', params: { id: form.id, response_id: response_id } }"
                >
                    <font-awesome-icon
                        icon="pencil-alt"
                        class="mr-1"
                    ></font-awesome-icon>
                    Edit Response
                </router-link>
            </div>
        </b-jumbotron>
    </b-container>
</template>
<script>
export default {
    props : ["id", "response_id"],
    data() {
        return {
            form    : {},
            loading : false
        };
    },
    mounted() {
        this.loadForm();
    },
    methods : {
        loadForm() {
            this.loading = true;
            this.$api.get(
                `/api/forms/${this.id}/fetch`
            ).then(({ data }) => {
                this.form    = data.form;
                this.loading = false;
            });
        }
    }
}
</script>